import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComponentIdentificationService {
  componentName: BehaviorSubject<string>;
  constructor() {
    this.componentName = new BehaviorSubject("");
  }
  changeComponentName(val) {
    this.componentName.next(val);
  }
}
